import { SelectDropdownOption } from "../components/APSelectDropDown";
import { AutoCompleteOption } from "../components/form/APAutoComplete";
import { PaginationFilters } from "./Pagination";
import { State } from "./State";

export type VehicleDealerRating = "preferred" | "standard" | "do-not-use";

export type VehicleDealerSortOption = "rating" | "vehicleSourcingFee";

export const VehicleDealerSortOptionsList: SelectDropdownOption<VehicleDealerSortOption>[] =
  [
    { id: "rating", label: "Rating" },
    { id: "vehicleSourcingFee", label: "Vehicle Sourcing Fee" },
  ];

export const vehicleDealerRatingOptions: AutoCompleteOption[] = [
  { label: "Preferred", id: "preferred" },
  { label: "Standard", id: "standard" },
  { label: "Do not use", id: "do-not-use" },
  { label: "All", id: "all" },
];

export const VehicleDealerRatingLabelMap: Record<VehicleDealerRating, string> =
  {
    preferred: "Preferred",
    standard: "Standard",
    "do-not-use": "Do not use",
  };

export type VehicleDealer = {
  id: string;
  primaryContactId: string | null;
  primaryContactName: string | null;
  accountId: string | null;
  name: string;
  address: string | null;
  state: State | null;
  email: string | null;
  vehicleSourcingFeeExGST: number | null;
  phone: string | null;
  rating: VehicleDealerRating | null;
};

export type VehicleDealerListFilters = PaginationFilters & {
  make: string;
  state: State | null;
  rating: VehicleDealerRating | null;
  nameSearch: string | null;
};
